import {RecipientType} from "@vue-app/modules/invoices/types.js";
import * as XLSX from 'xlsx'

export function useInvoiceExport() {
	const downloadFile = (content, filename, type) => {
		const blob = new Blob([content], { type })
		const url = URL.createObjectURL(blob)

		const link = document.createElement('a')
		link.href = url
		link.download = filename
		link.style.display = 'none'

		document.body.appendChild(link)
		link.click()

		document.body.removeChild(link)
		URL.revokeObjectURL(url)
	}

	const getRecipientContact = (inv) => {
		if (!inv?.recipient) return ''

		if (inv.recipient.type === 'individual') {
			const p = inv.recipient.person || {}
			return p.email || p.phone || ''
		}

		if (inv.recipient.type === 'legal') {
			return inv.recipient.legal?.EDRPOU || ''
		}

		return ''
	}

	const getRecipientName = (inv) => {
		if (!inv || !inv.recipient) return ''

		if (inv.recipient.type === RecipientType.INDIVIDUAL) {
			const p = inv.recipient.person || {}
			return `${p.firstName || ''} ${p.lastName || ''}`.trim()
		}

		return (inv.recipient.legal && inv.recipient.legal.name) || ''
	}

	const getInvoiceTotal = (inv) => {
		return Number(
			inv?.totalAmount ??
			inv?.totals?.totalAmount ??
			0
		)
	}

	const exportInvoices = ({
								scope,
								format,
								columns,
								invoices,
								filteredInvoices,
								selectedIds,
							}) => {
		const data =
			scope === 'selected'
				? invoices.filter(i => selectedIds.has(i.id))
				: filteredInvoices

		if (!data.length) {
			alert('No invoices to export')
			return
		}

		const filenameBase = `invoices_${new Date().toISOString().slice(0, 10)}`

		/* ================= CSV ================= */
		if (format === 'csv') {
			const header = columns.join(',')

			const rows = data.map(inv =>
				columns.map(col => {
					let val = ''

					switch (col) {
						case 'id': val = inv.id; break
						case 'date': val = inv.date; break
						case 'number': val = inv.number; break
						case 'status': val = inv.status; break
						case 'recipient': val = getRecipientName(inv); break
						case 'contact': return getRecipientContact(inv)
						case 'amount': val = getInvoiceTotal(inv).toFixed(2); break
						case 'currency': val = inv.currency; break
					}

					return `"${String(val).replace(/"/g, '""')}"`
				}).join(',')
			)

			const csv = '\uFEFF' + [header, ...rows].join('\n')

			downloadFile(
				csv,
				`${filenameBase}.csv`,
				'text/csv;charset=utf-8;'
			)
		}

		if (format === 'excel') {
			const rows = data.map(inv => {
				const row = {}

				columns.forEach(col => {
					switch (col) {
						case 'date': row.Date = inv.date; break
						case 'number': row.Number = inv.number; break
						case 'status': row.Status = inv.status; break
						case 'recipient': row.Recipient = getRecipientName(inv); break
						case 'contact': row.Contact = getRecipientContact(inv); break
						case 'amount': row.Amount = Number(getInvoiceTotal(inv)); break
						case 'currency': row.Currency = inv.currency; break
					}
				})

				return row
			})

			const worksheet = XLSX.utils.json_to_sheet(rows)

			const workbook = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(workbook, worksheet, 'Invoices')

			XLSX.writeFile(workbook, `${filenameBase}.xlsx`)
		}
	}

	return {
		exportInvoices,
	}
}
